import { render, staticRenderFns } from "./Success-component.vue?vue&type=template&id=aa800174&"
import script from "./Success-component.vue?vue&type=script&lang=js&"
export * from "./Success-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports